class LazyLoadManager {
  constructor() {
    this.stripeCallbacks = []
  }

  // Stripe

  // Trigger loading
  loadStripeIfNeeded() {
    if (window.Stripe) {
      this._callStripeCallbacks()
    } else {
      let stripeLoaderTag = document.querySelector('#stripe-js')
      if (!stripeLoaderTag) {
        stripeLoaderTag = document.createElement('script')
        stripeLoaderTag.id = 'stripe-js'
        stripeLoaderTag.type = 'text/javascript'
        stripeLoaderTag.async = true
        stripeLoaderTag.src = 'https://js.stripe.com/v3/'

        const firstScriptTag = document.getElementsByTagName('script')[0]
        firstScriptTag.parentNode.insertBefore(stripeLoaderTag, firstScriptTag)
      }
      stripeLoaderTag.addEventListener('load', () =>
        this._callStripeCallbacks()
      )
    }
  }

  // Register callback
  onStripeLoaded(callback) {
    this.stripeCallbacks.push(callback)
  }

  _callStripeCallbacks() {
    this.stripeCallbacks.map((cb) => cb())
    this.stripeCallbacks = []
  }
}

export const lazyLoadManager = new LazyLoadManager()
